import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, ChevronDown } from 'lucide-react';
export function LawyerAuth() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<'login' | 'signup'>(location.pathname === '/lawyer-signup' ? 'signup' : 'login');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });
  const [signupData, setSignupData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    lawSocietyNumber: '',
    province: '',
    password: '',
    confirmPassword: ''
  });
  const handleLoginChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value
    });
    if (e.target.name === 'email' && e.target.value.includes('@')) {
      setShowPassword(true);
    }
  };
  const handleSignupChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setSignupData({
      ...signupData,
      [e.target.name]: e.target.value
    });
    if (e.target.name === 'password' && e.target.value.length >= 1) {
      setShowConfirmPassword(true);
    }
  };
  const handleLoginSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle login logic here
  };
  const handleSignupSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle signup logic here
  };
  const handleSocialLogin = (provider: string) => {
    // Handle social login logic here
    console.log(`Login with ${provider}`);
  };
  return <div className="min-h-screen flex items-center justify-center px-4 pt-8 pb-12 bg-cover bg-center bg-no-repeat" style={{
    backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/2VXGuWX7WfqatMBg5PRveQ/pp.png')"
  }} data-id="element-2177">
      <div className="max-w-md w-full" data-id="element-2178">
        <Link to="/" className="inline-flex items-center text-[#6C3EF1] hover:text-[#5a32d4] mb-8 transition" data-id="element-2179">
          <ArrowLeft className="h-4 w-4 mr-2" data-id="element-2180" />
          Back to Home
        </Link>

        <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-2181">
          <div className="mb-8" data-id="element-2182">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o8GxAvVWkfzEpga9gSEiQA/Lawvo_logo_tm_01_large.png" alt="LawVo Logo" className="h-10 mb-8 mx-auto" data-id="element-2183" />
            <h1 className="text-2xl font-bold text-gray-900 text-center" data-id="element-2184">
              {activeTab === 'login' ? 'Lawyer Portal' : 'Join LawVo as a Lawyer'}
            </h1>
            <p className="text-sm text-gray-500 text-center mt-2 mb-6" data-id="element-2185">
              {activeTab === 'login' ? <>
                  Don't have an account yet?{' '}
                  <button onClick={() => setActiveTab('signup')} className="text-[#6C3EF1] hover:text-[#5a32d4] font-medium transition" data-id="element-2186">
                    Sign up now
                  </button>
                </> : <>
                  Already have an account?{' '}
                  <button onClick={() => setActiveTab('login')} className="text-[#6C3EF1] hover:text-[#5a32d4] font-medium transition" data-id="element-2187">
                    Sign in
                  </button>
                </>}
            </p>
          </div>

          {/* Login Form */}
          {activeTab === 'login' && <div data-id="element-2188">
              <form onSubmit={handleLoginSubmit} className="space-y-4" data-id="element-2189">
                <div data-id="element-2190">
                  <input type="email" id="login-email" name="email" value={loginData.email} onChange={handleLoginChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Enter your email" required data-id="element-2191" />
                </div>
                {showPassword && <div data-id="element-2192">
                    <input type="password" id="login-password" name="password" value={loginData.password} onChange={handleLoginChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Enter your password" required data-id="element-2193" />
                    <div className="text-right mt-1.5" data-id="element-2194">
                      <a href="#" className="text-xs text-[#00dace] hover:text-[#00b8aa] transition" data-id="element-2195">
                        Forgot your password?
                      </a>
                    </div>
                  </div>}
                <button type="submit" className="w-full bg-[#6C3EF1] text-white py-3 px-6 rounded-lg hover:bg-[#5a32d4] transition font-medium" data-id="element-2196">
                  Continue
                </button>
              </form>

              {/* Divider */}
              <div className="flex items-center my-6" data-id="element-2197">
                <div className="flex-1 border-t border-gray-300" data-id="element-2198"></div>
                <span className="px-4 text-sm text-gray-500" data-id="element-2199">or use</span>
                <div className="flex-1 border-t border-gray-300" data-id="element-2200"></div>
              </div>

              {/* Social Login Buttons */}
              <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-2201">
                <button onClick={() => handleSocialLogin('google')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-2202">
                  <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5" data-id="element-2203" />
                  <span className="text-sm font-medium text-gray-700" data-id="element-2204">
                    Google
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('microsoft')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-2205">
                  <svg className="w-5 h-5" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2206">
                    <rect width="11" height="11" fill="#F25022" data-id="element-2207" />
                    <rect x="12" width="11" height="11" fill="#7FBA00" data-id="element-2208" />
                    <rect y="12" width="11" height="11" fill="#00A4EF" data-id="element-2209" />
                    <rect x="12" y="12" width="11" height="11" fill="#FFB900" data-id="element-2210" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-2211">
                    Microsoft
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('linkedin')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-2212">
                  <svg className="w-5 h-5" fill="#0A66C2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-2213">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-2214" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-2215">
                    LinkedIn
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('apple')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-2216">
                  <svg className="w-5 h-5" fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-2217">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" data-id="element-2218" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-2219">
                    Apple
                  </span>
                </button>
              </div>
            </div>}

          {/* Signup Form */}
          {activeTab === 'signup' && <div data-id="element-2220">
              <form onSubmit={handleSignupSubmit} className="space-y-4" data-id="element-2221">
                <div className="grid grid-cols-2 gap-4" data-id="element-2222">
                  <div data-id="element-2223">
                    <input type="text" id="firstName" name="firstName" value={signupData.firstName} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="First Name" required data-id="element-2224" />
                  </div>
                  <div data-id="element-2225">
                    <input type="text" id="lastName" name="lastName" value={signupData.lastName} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Last Name" required data-id="element-2226" />
                  </div>
                </div>
                <div data-id="element-2227">
                  <input type="email" id="signup-email" name="email" value={signupData.email} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Email Address" required data-id="element-2228" />
                </div>
                <div data-id="element-2229">
                  <input type="tel" id="phone" name="phone" value={signupData.phone} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Phone Number" required data-id="element-2230" />
                </div>

                {/* Lawyer Specific Fields */}
                <div className="grid grid-cols-2 gap-4" data-id="element-2231">
                  <div data-id="element-2232">
                    <input type="text" id="lawSocietyNumber" name="lawSocietyNumber" value={signupData.lawSocietyNumber} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Law Society #" required data-id="element-2233" />
                  </div>
                  <div className="relative" data-id="element-2234">
                    <select id="province" name="province" value={signupData.province} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition appearance-none bg-white text-gray-900 cursor-pointer" required data-id="element-2235">
                      <option value="" disabled data-id="element-2236">
                        Province
                      </option>
                      <option value="AB" data-id="element-2237">Alberta</option>
                      <option value="BC" data-id="element-2238">British Columbia</option>
                      <option value="MB" data-id="element-2239">Manitoba</option>
                      <option value="NB" data-id="element-2240">New Brunswick</option>
                      <option value="NL" data-id="element-2241">Newfoundland and Labrador</option>
                      <option value="NS" data-id="element-2242">Nova Scotia</option>
                      <option value="ON" data-id="element-2243">Ontario</option>
                      <option value="PE" data-id="element-2244">Prince Edward Island</option>
                      <option value="QC" data-id="element-2245">Quebec</option>
                      <option value="SK" data-id="element-2246">Saskatchewan</option>
                      <option value="NT" data-id="element-2247">Northwest Territories</option>
                      <option value="NU" data-id="element-2248">Nunavut</option>
                      <option value="YT" data-id="element-2249">Yukon</option>
                    </select>
                    <ChevronDown className="absolute right-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" data-id="element-2250" />
                  </div>
                </div>

                <div data-id="element-2251">
                  <input type="password" id="signup-password" name="password" value={signupData.password} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Password" required data-id="element-2252" />
                </div>
                {showConfirmPassword && <div data-id="element-2253">
                    <input type="password" id="confirmPassword" name="confirmPassword" value={signupData.confirmPassword} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Confirm Password" required data-id="element-2254" />
                  </div>}
                <div className="flex items-start" data-id="element-2255">
                  <input type="checkbox" id="terms" className="h-4 w-4 text-[#6C3EF1] focus:ring-[#6C3EF1] border-gray-300 rounded mt-1" required data-id="element-2256" />
                  <label htmlFor="terms" className="ml-2 text-xs text-gray-600" data-id="element-2257">
                    I confirm that I have read, understood, and agree to LawVo's{' '}
                    <a href="#" className="text-[#00dace] hover:underline" data-id="element-2258">
                      Terms & Conditions
                    </a>{' '}
                    and{' '}
                    <a href="#" className="text-[#00dace] hover:underline" data-id="element-2259">
                      Privacy Policy
                    </a>
                  </label>
                </div>
                <div className="flex items-start" data-id="element-2260">
                  <input type="checkbox" id="marketing" className="h-4 w-4 text-[#6C3EF1] focus:ring-[#6C3EF1] border-gray-300 rounded mt-1" data-id="element-2261" />
                  <label htmlFor="marketing" className="ml-2 text-xs text-gray-600" data-id="element-2262">
                    I agree to receive updates, offers, and communications from
                    LawVo.
                  </label>
                </div>
                <button type="submit" className="w-full bg-[#6C3EF1] text-white py-3 px-6 rounded-lg hover:bg-[#5a32d4] transition font-medium" data-id="element-2263">
                  Create Account
                </button>
              </form>

              {/* Divider */}
              <div className="flex items-center my-6" data-id="element-2264">
                <div className="flex-1 border-t border-gray-300" data-id="element-2265"></div>
                <span className="px-4 text-sm text-gray-500" data-id="element-2266">or use</span>
                <div className="flex-1 border-t border-gray-300" data-id="element-2267"></div>
              </div>

              {/* Social Signup Buttons */}
              <div className="grid grid-cols-2 gap-3" data-id="element-2268">
                <button onClick={() => handleSocialLogin('google')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-2269">
                  <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5" data-id="element-2270" />
                  <span className="text-sm font-medium text-gray-700" data-id="element-2271">
                    Google
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('microsoft')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-2272">
                  <svg className="w-5 h-5" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2273">
                    <rect width="11" height="11" fill="#F25022" data-id="element-2274" />
                    <rect x="12" width="11" height="11" fill="#7FBA00" data-id="element-2275" />
                    <rect y="12" width="11" height="11" fill="#00A4EF" data-id="element-2276" />
                    <rect x="12" y="12" width="11" height="11" fill="#FFB900" data-id="element-2277" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-2278">
                    Microsoft
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('linkedin')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-2279">
                  <svg className="w-5 h-5" fill="#0A66C2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-2280">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-2281" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-2282">
                    LinkedIn
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('apple')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-2283">
                  <svg className="w-5 h-5" fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-2284">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" data-id="element-2285" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-2286">
                    Apple
                  </span>
                </button>
              </div>
            </div>}
        </div>

        {/* Mobile App Download Section */}
        <div className="mt-5 flex items-center justify-center gap-3" data-id="element-2287">
          <a href="#" className="inline-block hover:opacity-80 transition" data-id="element-2288">
            <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83" alt="Download on the App Store" className="h-[32px] w-auto" data-id="element-2289" />
          </a>
          <a href="#" className="inline-block hover:opacity-80 transition" data-id="element-2290">
            <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" className="h-[48px] w-auto" data-id="element-2291" />
          </a>
        </div>

        {/* Individual Login Link */}
        <div className="mt-8 text-center" data-id="element-2292">
          <Link to="/login" className="text-sm text-white/80 hover:text-white transition font-medium" data-id="element-2293">
            Not a lawyer? Sign in here &rarr;
          </Link>
        </div>
      </div>
    </div>;
}